var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { WP_QUICKTASKER_INVALID_SESSION_TOKEN } from "../../constants";
import { UserPageAppContext } from "../providers/UserPageAppContextProvider";
import { useSession } from "./useSession";
function useErrorHandler() {
    const { loadUserPageStatus } = useContext(UserPageAppContext);
    const { deleteSessionCookie } = useSession();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleError = (error) => __awaiter(this, void 0, void 0, function* () {
        console.error(error);
        if (error.messages &&
            Array.isArray(error.messages) &&
            error.messages.length > 0) {
            const errorMessage = error.messages.join(", ");
            const hasInvalidTokenError = errorMessage.includes(WP_QUICKTASKER_INVALID_SESSION_TOKEN);
            if (hasInvalidTokenError) {
                toast.info(__("Your session has expired. Please log in to continue.", "quicktasker"));
                yield deleteSessionCookie();
                loadUserPageStatus();
            }
            else {
                toast.error(errorMessage);
            }
        }
    });
    return {
        handleError,
    };
}
export { useErrorHandler };
